
export const ALPHABET_VALUES = [
    { value: 'A_TO_E', name: "A, B, C, D, E", data: ["A", "B", "C", "D", "E"], type: 'alphabet' },
    { value: 'F_TO_J', name: "F, G, H, I, J", data: ["F", "G", "H", "I", "J"], type: 'alphabet' },
    { value: 'K_TO_O', name: "K, L, M, N, O", data: ["K", "L", "M", "N", "O"], type: 'alphabet' },
    { value: 'P_TO_T', name: "P, Q, R, S, T", data: ["P", "Q", "R", "S", "T"], type: 'alphabet' },
    { value: 'U_TO_Z', name: 'U, V, W, X, Y, Z', data: ["U", "V", "W", "X", "Y", "Z"], type: 'alphabet' }, 
    { value: 'ALL', name: "Tất cả", data: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"], type: 'alphabet' },
]